import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../components/site/Reveal";
import { Seo } from "../components/site/Seo";
import { Lightbox } from "../components/site/Lightbox";
import { STUDIO, HOURS, SHOP_IMAGES } from "../data/site";

export default function Studio() {
  const [lightbox, setLightbox] = useState(null);

  return (
    <>
      <Seo title="The Studio" description="Inside Obsidian Art & Tattoo Studio in Springfield, VA — a licensed team, multiple disciplines and a space built for permanent art." />

      <section className="pt-36 lg:pt-44 pb-20 max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16 border-b border-ash">
        <Reveal><p className="eyebrow mb-6">The studio</p></Reveal>
        <Reveal delay={60}><h1 className="display text-6xl sm:text-7xl lg:text-[8vw] text-white max-w-5xl leading-[0.9]">A destination for tattoo artistry.</h1></Reveal>
        <Reveal delay={120}><p className="mt-10 max-w-2xl text-[#9E9EA8] text-lg leading-relaxed">Obsidian Art & Tattoo Studio is home to a fully licensed team who attend — and often lead — conventions and workshops to stay sharp on technique and craft. From minimal designs to large custom pieces, we treat every tattoo as a piece of art that reflects both the artist's skill and the client's story.</p></Reveal>
      </section>

      <section className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16 py-24 border-b border-ash">
        <Reveal><p className="eyebrow mb-8">The shop</p></Reveal>
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-3 lg:gap-5 [column-fill:_balance]">
          {SHOP_IMAGES.map((src, i) => (
            <Reveal key={i} delay={(i % 3) * 50} className="mb-3 lg:mb-5 break-inside-avoid">
              <button onClick={() => setLightbox(src)} data-testid={`shop-image-${i}`} className="mono-hover img-zoom group relative block w-full overflow-hidden border border-ash">
                <img src={src} alt="Inside Obsidian Art & Tattoo Studio" loading="eager" className="w-full object-cover" />
              </button>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16 py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <p className="eyebrow mb-6">Visit</p>
            <h2 className="display text-4xl lg:text-5xl text-white leading-tight">{STUDIO.address}<br />{STUDIO.cityStateZip}</h2>
            <div className="mt-8 flex flex-col gap-2 text-[#C4C4CC]">
              <a href={STUDIO.phoneHref} className="link-underline w-fit">{STUDIO.phone}</a>
            </div>
            <Link to="/booking" className="inline-flex items-center gap-3 mt-10 bg-ember text-obsidian font-mono text-xs uppercase tracking-[0.2em] font-semibold px-8 py-4 hover:bg-white transition-colors">Book a Session <ArrowRight size={14} /></Link>
          </div>
          <div className="lg:col-span-6">
            <p className="eyebrow mb-6">Hours</p>
            <ul className="divide-y divide-ash border-y border-ash">
              {HOURS.map((h) => (
                <li key={h.day} className="flex items-center justify-between py-5">
                  <span className="font-serif text-2xl text-white">{h.day}</span>
                  <span className="font-mono text-xs uppercase tracking-widest text-[#828290]">{h.time}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <Lightbox src={lightbox} onClose={() => setLightbox(null)} />
    </>
  );
}
